import { Loader2, CheckCircle2, AlertCircle, X, UploadCloud } from "lucide-react";
import { useUploads, dismissUpload, formatSize } from "@/lib/uploads";

export default function UploadProgress() {
  const uploads = useUploads();
  if (!uploads.length) return null;
  return (
    <div data-testid="upload-progress-panel" className="fixed bottom-4 right-4 z-[100] w-[min(92vw,360px)] space-y-2">
      {uploads.map((u) => (
        <div key={u.id} data-testid="upload-progress-item" className="rounded-xl border border-white/10 bg-[#0B1220]/95 backdrop-blur-xl p-3 shadow-2xl">
          <div className="flex items-center gap-2">
            {u.status === "done" ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
              : u.status === "error" ? <AlertCircle className="w-4 h-4 text-destructive shrink-0" />
              : u.status === "processing" ? <Loader2 className="w-4 h-4 text-gold animate-spin shrink-0" />
              : <UploadCloud className="w-4 h-4 text-gold shrink-0" />}
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold truncate" title={u.name}>{u.name}</p>
              <p className="text-[11px] text-muted-foreground" data-testid="upload-progress-status">
                {u.status === "done" ? "Caricamento completato"
                  : u.status === "error" ? "Caricamento non riuscito"
                  : u.status === "processing" ? "Elaborazione sul server…"
                  : `${formatSize(u.loaded)} di ${formatSize(u.size)} · ${u.percent}%`}
              </p>
            </div>
            <button type="button" onClick={() => dismissUpload(u.id)} className="text-muted-foreground hover:text-foreground" aria-label="Chiudi"><X className="w-3.5 h-3.5" /></button>
          </div>
          <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
            <div
              className={`h-full rounded-full transition-[width] duration-200 ${u.status === "error" ? "bg-destructive" : u.status === "done" ? "bg-emerald-400" : "bg-gold"} ${u.status === "processing" ? "animate-pulse" : ""}`}
              style={{ width: `${Math.max(2, u.percent)}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
